import React from 'react'

function backgroundValue(value) {
    if (!value) return 'url("")'
    const stringValue = String(value)
    if (stringValue.indexOf('url(') > -1 || stringValue.indexOf('gradient(') > -1) return stringValue
    return 'url("' + stringValue + '")'
}

function borderValue(value) {
    const stringValue = String(value || '').trim()
    if (!stringValue) return '1px solid #ffffff'
    if (stringValue.indexOf('solid') > -1) return stringValue
    return '1px solid ' + stringValue
}

function previewClientStyles(styles) {
    const source = styles || {}
    return {
        '--bodyTxt': source.bodyTxt || '#ffffff',
        '--livePrizePoolLabelBg': source.livePrizePoolLabelBg || '#ff0000',
        '--livePrizePoolLabelTxt': source.livePrizePoolLabelTxt || '#ffffff',
        '--primaryBtnBg': source.primaryBtnBg || '#ff0000',
        '--primaryBtnTxt': source.primaryBtnTxt || '#ffffff',
        '--secondaryBtnBorder': borderValue(source.secondaryBtnBorder),
        '--secondaryBtnTxt': source.secondaryBtnTxt || '#ffffff',
        '--splitPrizeBg': source.splitPrizeBg || '#ffffff',
        '--splitPrizeTxt': source.splitPrizeTxt || '#0000ff',
        '--ticketsSoldTxt': source.ticketsSoldTxt || '#ffcc00',
        '--background': backgroundValue(source.background),
        '--backgroundOverlayColor': source.backgroundOverlayColor || '#000000',
        '--backgroundOverlayOpacity': source.backgroundOverlayOpacity === undefined || source.backgroundOverlayOpacity === null ? 0 : source.backgroundOverlayOpacity,
        '--logoBg': source.logoBg || 'transparent'
    }
}

function logoImageStyle(styles) {
    const source = styles || {}
    return {
        transform: 'translate(' + ((Number(source.logoOffsetX || 0) * 100).toFixed(3)) + '%, ' + ((Number(source.logoOffsetY || 0) * 100).toFixed(3)) + '%) scale(' + Number(source.logoScale || 1) + ')',
        transformOrigin: 'center center'
    }
}

function previewSkinClass(styles) {
    const skin = styles && styles.skin ? styles.skin : 'classic'
    if (skin === 'spotlight') return 's50-preview s50-preview--spotlight'
    return 's50-preview s50-preview--classic'
}

class PublicBuyTicketsPreview extends React.Component {
    _logoFrameClass(frame) {
        if (frame === 'circle') return 'rounded-full'
        if (frame === 'rounded') return 'rounded-[28px]'
        if (frame === 'square') return 'rounded-none'
        return ''
    }

    render() {
        const client = this.props.client || {}
        const event = this.props.event || {}
        const styles = previewClientStyles(client.styles)
        const scaleClass = this.props.scaleClassName || 'scale-[0.9]'
        const logoFrame = client.styles && client.styles.logoFrame ? client.styles.logoFrame : 'none'
        const logoBg = client.styles && client.styles.logoBg ? client.styles.logoBg : ''
        const logoStyle = logoImageStyle(client.styles)
        const bundles = Object.keys(event.bundles || {})
            .sort((a, b) => Number(a) - Number(b))
            .map((price) => ({
                price,
                count: event.bundles[price]
            }))
        const selectedBundle = bundles.length ? bundles[Math.min(2, bundles.length - 1)] : { count: 1, price: 5 }

        return (
            <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-slate-100 p-5 dark:border-slate-800 dark:bg-slate-900/80">
                <div className="flex justify-center overflow-hidden">
                    <div className="s50-preview-viewport flex justify-center">
                        <div className={'origin-top ' + scaleClass}>
                                <div className={previewSkinClass(client.styles)} style={styles}>
                                <div className="s50-preview__background">
                                    {client.styles && client.styles.hero ?
                                        <div className="s50-preview__hero">
                                            <img src={client.styles.hero} alt="hero" />
                                        </div>
                                        : null}
                                    <div className="s50-preview__background-overlay" />
                                    <div className="s50-preview__progress">
                                        <div className="s50-preview__progress-bar" />
                                    </div>
                                    <div className="s50-preview__content-wrap">
                                        <div className="s50-preview__content s50-preview__content--buy">
                                            {client.styles && client.styles.logo ?
                                                <div className={'s50-preview__logo-frame ' + this._logoFrameClass(logoFrame)} style={logoBg ? { background: logoBg } : null}>
                                                    <img src={client.styles.logo} className="s50-preview__logo" alt="logo" style={logoStyle} />
                                                </div>
                                                : null}
                                            <div className="s50-preview__chevron">
                                                Live Prize Pool
                                            </div>
                                            <div className="s50-preview__prizepool">
                                                <span>${Number(event.prizePool || 0).toFixed(2)}</span>
                                            </div>
                                            <div className="s50-preview__eventno">
                                                <span>EVENT #{event.SK || 'PREVIEW_001'}</span>
                                                {event.license ?
                                                    <>
                                                        <br />
                                                        <span>{event.license}</span>
                                                    </>
                                                    : null}
                                            </div>

                                            <div className="s50-preview__buy-group">
                                                <div className="s50-preview__buy-bundles">
                                                    {bundles.map((bundle, index) => (
                                                        <button
                                                            key={bundle.price + '-' + bundle.count}
                                                            type="button"
                                                            className={'s50-preview__buy-bundle ' + (index === Math.min(2, bundles.length - 1) ? 's50-preview__buy-bundle--active' : '')}
                                                        >
                                                            <b>{bundle.count}</b> for <b>${bundle.price}</b>
                                                        </button>
                                                    ))}
                                                </div>

                                                <div className="s50-preview__buy-form">
                                                    <h4>Personal Details</h4>
                                                    <div className="s50-preview__buy-label">Mobile Number. This is where your tickets will be sent so please make sure it is correct.</div>
                                                    <div className="s50-preview__buy-input">Enter phone</div>
                                                    <div className="s50-preview__buy-label">Email</div>
                                                    <div className="s50-preview__buy-input">Enter email</div>
                                                    <div className="s50-preview__buy-check">
                                                        <span className="s50-preview__buy-check-box" />
                                                        <span>{client.optInMessage || 'Send me promotional material'}</span>
                                                    </div>
                                                </div>

                                                <div className="s50-preview__buy-form">
                                                    <h4>Payment Details</h4>
                                                    <div className="s50-preview__buy-label">Name on Card</div>
                                                    <div className="s50-preview__buy-input">Enter name</div>
                                                    <div className="s50-preview__buy-label">Card Number</div>
                                                    <div className="s50-preview__buy-input">Enter Card Number</div>
                                                    <div className="grid grid-cols-2 gap-3">
                                                        <div>
                                                            <div className="s50-preview__buy-label">Expiry Month</div>
                                                            <div className="s50-preview__buy-input">Choose...</div>
                                                        </div>
                                                        <div>
                                                            <div className="s50-preview__buy-label">Expiry Year</div>
                                                            <div className="s50-preview__buy-input">Choose...</div>
                                                        </div>
                                                    </div>
                                                    <div className="s50-preview__buy-label">CVC</div>
                                                    <div className="s50-preview__buy-input">CVC</div>
                                                    <div className="s50-preview__buy-terms">
                                                        By purchasing tickets you have read and agreed to the <span>Terms and conditions</span>
                                                    </div>
                                                </div>

                                                {event.addressRequired ?
                                                    <div className="s50-preview__buy-form">
                                                        <h4>Address</h4>
                                                        <div className="s50-preview__buy-label">Unit / Number</div>
                                                        <div className="s50-preview__buy-input">Unit / Number</div>
                                                        <div className="s50-preview__buy-label">Street</div>
                                                        <div className="s50-preview__buy-input">Street</div>
                                                        <div className="s50-preview__buy-label">Suburb</div>
                                                        <div className="s50-preview__buy-input">Suburb</div>
                                                        <div className="grid grid-cols-2 gap-3">
                                                            <div>
                                                                <div className="s50-preview__buy-label">State</div>
                                                                <div className="s50-preview__buy-input">SA</div>
                                                            </div>
                                                            <div>
                                                                <div className="s50-preview__buy-label">Postcode</div>
                                                                <div className="s50-preview__buy-input">Postcode</div>
                                                            </div>
                                                        </div>
                                                        <div className="s50-preview__buy-terms">
                                                            By purchasing tickets you have read and agreed to the <span>Terms and conditions</span>
                                                        </div>
                                                    </div>
                                                    : null}

                                                <button className="s50-preview__button s50-preview__button--primary">
                                                    Buy {selectedBundle.count} Tickets for ${selectedBundle.price}
                                                </button>
                                                <button className="s50-preview__button s50-preview__button--secondary s50-preview__button--back">← Back</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PublicBuyTicketsPreview
